import { Extension } from '@tiptap/core'
import { Fragment, DOMParser as PMParser, Slice } from 'prosemirror-model'
import { Plugin } from 'prosemirror-state'

export const InsertGapOnPaste = Extension.create({
  name: 'insertGapOnPaste',

  addProseMirrorPlugins() {
    return [
      new Plugin({
        props: {
          handlePaste(view, event) {
            const html = event.clipboardData?.getData('text/html')
            if (!html) return false

            // 1) parse HTML → initial Slice
            const dom = new DOMParser().parseFromString(html, 'text/html')

            // 2) If it’s a table, bail out so default table-paste kicks in:
            if (dom.body.querySelector('table')) {
              return false
            }

            // 3) If this HTML has ProseMirror’s marker, do a normal paste
            //  and skip your gap-injection logic entirely.
            if (dom.body.querySelector('[data-pm-slice]')) {
              event.preventDefault()
              const slice = PMParser.fromSchema(view.state.schema).parseSlice(
                dom.body
              )
              view.dispatch(view.state.tr.replaceSelection(slice))
              return true
            }

            // 3) Otherwise, this is external content → inject empty <p> between paragraphs
            event.preventDefault()

            const parser = PMParser.fromSchema(view.state.schema)
            let slice = parser.parseSlice(dom.body)

            // 4) rebuild content, injecting empty <p> only when next exists
            const nodes: any[] = []
            const { content } = slice
            const childCount = content.childCount

            for (let i = 0; i < childCount; i++) {
              const node = content.child(i)
              nodes.push(node)

              // only check for a “next” if i+1 < childCount
              if (
                i < childCount - 1 &&
                node.type.name === 'paragraph' &&
                content.child(i + 1).type.name === 'paragraph'
              ) {
                const emptyPara =
                  view.state.schema.nodes.paragraph.createAndFill()
                if (emptyPara) {
                  nodes.push(emptyPara)
                }
              }
            }

            // 3) reassemble a new Slice and insert
            slice = new Slice(
              Fragment.fromArray(nodes),
              slice.openStart,
              slice.openEnd
            )
            const tr = view.state.tr.replaceSelection(slice)
            view.dispatch(tr)
            return true
          },
        },
      }),
    ]
  },
})
